import type { TabPanelPassThroughOptions } from "primevue/tabpanel";

export const tabpanel: TabPanelPassThroughOptions = {
  root: "focus:outline-none focus:outline-offset-0 focus-visible:ring-1 ring-inset focus-visible:ring-primary-400 dark:focus-visible:ring-primary-300"
};
